import config from 'constants/config'
import { getTripURL } from '.'

export const getClipboardUrl = (
  currentRegionCode: string,
  isPublicVersion: boolean,
  privateId: string,
  publicId: string | undefined,
) => {
  const protocol =
    typeof window !== 'undefined' ? window.location.protocol : 'https:'
  const baseUrl = `${protocol}//${config.CUSTOMER_PORTAL_HOST}/${currentRegionCode.toLowerCase()}`

  if (publicId && isPublicVersion) {
    return `${baseUrl}${getPublicTripURL(publicId)}`
  }

  return `${baseUrl}${getTripURL(privateId)}`
}

export function getPublicTripURL(tripId: string): string {
  return `/trip-planner/public-trip/${tripId}/itinerary`
}
